import queryString from 'query-string';
import { Component } from 'react';
import { Location, NavigateFunction, useLocation, useNavigate } from 'react-router-dom';

type HoCLoginHandlerComponentProps = {
  fetch: any
}
type LoginHandlerComponentProps = HoCLoginHandlerComponentProps & {
  location: Location<any>;
  navigate: NavigateFunction
}

export default function HoCLoginHandlerComponent(props: HoCLoginHandlerComponentProps) {
  const location = useLocation()
  const navigate = useNavigate()
  return <LoginHandlerComponent {...props} location={location} navigate={navigate}/>
}

class LoginHandlerComponent extends Component<LoginHandlerComponentProps> {
  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    this.props.fetch(values.code, this.props.navigate);
  }

  render() {
    return <></>;
  }
}
